export let DeliveryKeys = /*#__PURE__*/function (DeliveryKeys) {
  DeliveryKeys["FirstName"] = "firstName";
  DeliveryKeys["FormFirstName"] = "fname";
  DeliveryKeys["LastName"] = "lastName";
  DeliveryKeys["FormLastName"] = "lname";
  DeliveryKeys["Company"] = "company";
  DeliveryKeys["Email"] = "email";
  DeliveryKeys["PhoneNumber"] = "phoneNumber";
  DeliveryKeys["FirstNameShipping"] = "fnameShipping";
  DeliveryKeys["LastNameShipping"] = "lnameShipping";
  DeliveryKeys["Address"] = "address";
  DeliveryKeys["Unit"] = "unit";
  DeliveryKeys["City"] = "city";
  DeliveryKeys["State"] = "state";
  DeliveryKeys["Country"] = "country";
  DeliveryKeys["Zip"] = "zip";
  DeliveryKeys["FormPhone"] = "phone";
  DeliveryKeys["DeliveryNote"] = "deliveryNote";
  DeliveryKeys["IsDeliveryPrefilled"] = "isDeliveryPrefilled";
  DeliveryKeys["CompanyDepartmentId"] = "companyDepartmentId";
  DeliveryKeys["Promocode"] = "promocode";
  return DeliveryKeys;
}({});